import ModalCloseButton from 'ui/v1/controls/ModalCloseButton.vue';
export default {
    name: 'UiModal',
    components: {
        ModalCloseButton: ModalCloseButton,
    },
    props: {
        autoHide: {
            type: Boolean,
            default: true,
        },
        withCloseButton: {
            type: Boolean,
            default: false,
        },
        closeButtonIcon: {
            type: String,
            default: 'close-c',
        },
    },
    data: function () {
        var _this = this;
        return {
            visible: false,
            listener: function (event) {
                if ([27, 'Esc', 'Escape'].includes(event.key)) {
                    _this.close();
                }
            },
        };
    },
    computed: {
        hasHeader: function () {
            return !!this.$slots.header;
        },
        hasFooter: function () {
            return !!this.$slots.footer;
        },
    },
    methods: {
        hide: function () {
            document.removeEventListener('keyup', this.listener);
            this.visible = false;
            document.body.classList.remove('modal-showing');
        },
        close: function () {
            if (this.autoHide || this.withCloseButton) {
                this.hide();
                this.$emit('modalClosed');
            }
        },
        show: function () {
            document.addEventListener('keyup', this.listener);
            this.visible = true;
            document.body.classList.add('modal-showing');
        },
    },
};
